import api from '@/api/api';
import type { ServiceTokenCreated, ServiceTokenItem } from '@/interfaces/ServiceTokens';

export const getServiceTokens = async (): Promise<ServiceTokenItem[]> => {
  const response = await api.get<ServiceTokenItem[]>('/tokens');
  return response.data;
};

/** Creates a token; the response carries the plaintext exactly once. */
export const createServiceToken = async (name: string): Promise<ServiceTokenCreated> => {
  const response = await api.post<ServiceTokenCreated>('/tokens', { name });
  return response.data;
};

export const revokeServiceToken = async (id: number): Promise<ServiceTokenItem> => {
  const response = await api.post<ServiceTokenItem>(`/tokens/${id}/revoke`);
  return response.data;
};
